import { render, staticRenderFns } from "./JointPrivacy.vue?vue&type=template&id=a9232c12"
import script from "./JointPrivacy.vue?vue&type=script&lang=js"
export * from "./JointPrivacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports